// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","966":"login"}[chunkId] + "." + {"594":"b2883159","966":"22fc6e34"}[chunkId] + ".css";
};